import router from './router'
import store from './store'
import { Login  } from 'api/login.js'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie
import { getToken,fBrowserRedirect,setBalance,getPassword  } from '@/utils/auth-session'

import getPageTitle from '@/utils/get-page-title'
import { login } from './api/user'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login','/CodeLog','/QaCode'] // no redirect whitelist

// 路由前置守卫
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  // document.title = getPageTitle(to.meta.title)
  document.title = '快遞中心有限公司 CXC EXPRESS LTD'

  // determine whether the user has logged in
  // 判断登录时后端返回的 token 是否存在
  const hasToken = getToken()

  // 存在token
  if (hasToken) {

    if(store.state.user.balance){

         if(store.state.user.phone!=""){
      let user= localStorage.getItem('code');

      let pwd=getPassword();
      let loginForm={
        user,
        pwd
      }

      store.dispatch('user/login', loginForm)

      //      Login(user, pwd).then(res=>{

      //       if(typeof (res.data.balance)!="undefined"){
      //         let b=res.data.balance
      //          setBalance(b)
      //
      //       // store.commit('set_balance',b)



      //        }
      // })

      }

    }

    // console.log('是否存在token,toke为:',hasToken)
    if (to.path === '/login') {
      console.log('去的是登录页，重定向到主页',hasToken)
      //如果已登录，则重定向到主页
      next({ path: '/' })
      NProgress.done()
    } else {
      // 不是登录页  重新进行登录
      // console.log('第一次進入登录页,能獲取到store中的用戶信息：',hasToken)
      const hasGetName = store.getters.name
      const hasGetCode = store.getters.code
      // 是否存在用户信息
      if (hasGetName || hasGetCode) {
        console.log('用户信息已存在，用户名称为:', hasGetName);
        console.log('用户信息已存在，用户標號为:', hasGetCode);
        // 存在执行任务
        next()
      }else {
        console.log('刷新頁面獲取不到用戶信息，從本地存儲中獲取:',localStorage.getItem('name'));

          // 不存在用户信息则跳转到登录页面重新登录
          // await store.dispatch('user/resetToken')
          // Message.error(error || 'Has Error')
          // next(`/login?redirect=${to.path}`)
          next();
          NProgress.done()
      }
    }
  } else {
    /* has no token*/
    // 不存在 token
    console.log('不存在 token,token为：',hasToken)
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      // 在免费登录白名单中，直接进入

      console.log('在免费登录白名单中，直接进入')
      next()
    }else if(to.path === '/register'){
      console.log('是注册页面，直接进入')
      next()
      NProgress.done()
    } else {
      if(fBrowserRedirect()==2 && sessionStorage.getItem('Mobile')==11){
        window.android_cxc_os.logoutOs();
      }
        console.log("沒有權限")
      // 其他没有访问权限的页面将被重定向到登录页面。
      // next(`/login?redirect=${to.path}`)
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
